import { Common } from '@stockbit/ui';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import auth from 'utils/auth';
import InfiniteScroll from 'global/InfiniteScroll';
import StreamTabAnalytics from 'features/stream/analytics/StreamTabAnalytics';
import UserItem from './UserItem';

import { effects, selectors } from '../../slice';
import { UserListContainer, Modal } from './styled';

const { Text } = Common;
interface ModalLikeProps {
  streamId: number;
  visible: boolean;
  likes: number;
  [key: string]: any;
}

function ModalLike({ likes, streamId, visible, ...props }: ModalLikeProps) {
  const dispatch = useDispatch();

  const [page, setPage] = useState<number>(1);
  const user = auth.getUserAccess();
  // @ts-ignore
  const { id: userId } = user;
  let userAccountId = 0;
  if (userId) {
    userAccountId = userId;
  }

  const {
    streamLikers: { data: streamLikersData, isLoading },
  } = useSelector(selectors);

  const isLastPage = streamLikersData[streamId]?.more === false;
  const likersData = streamLikersData[streamId]?.likers || [];

  const handleGetLikers = async () => {
    const params = {
      postid: streamId,
      page: 1,
    };

    // @ts-ignore
    const getLikers = await dispatch(effects.getStreamLikers(params));

    // @ts-ignore
    const { error } = getLikers.payload;

    if (!error) {
      setPage(page + 1);
    }
  };

  const handleLoadMoreLikers = async () => {
    const params = {
      postid: streamId,
      page,
    };

    if (!isLastPage) {
    // @ts-ignore
      const getLikers = await dispatch(effects.getStreamLikers(params));

      // @ts-ignore
      const { error } = getLikers.payload;

      if (!error) {
        setPage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (visible) {
      handleGetLikers();
      StreamTabAnalytics.common.View.onLikesViewed();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <Modal
      {...props}
      type="fullscreen"
      visible={visible}
      footer={null}
      destroyOnClose
      title={(
        <Text align="center" size="20px" height="30px" family="bold">
          Liked by {likes} people
        </Text>
      )}
      transitionName=""
      maskTransitionName=""
    >
      <UserListContainer>
        <InfiniteScroll
          refineNext={handleLoadMoreLikers}
          hasMore={!isLastPage}
          loader={<div />}
          isLoading={isLoading || !streamLikersData[streamId]}
          style={{
            height: '100%',
            maxHeight: 650,
            overflow: 'auto',
            paddingRight: 10,
          }}
        >
          {likersData.map((u) => (
            <UserItem
              key={u.id}
              user={u}
              postid={streamId}
              hasButton={u.id !== userAccountId}
            />
          ))}
        </InfiniteScroll>
      </UserListContainer>
    </Modal>
  );
}

export default ModalLike;
